import {Component, OnInit, Inject, ElementRef, OnDestroy} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TasksService} from '../../../../../data/tasks/tasks.service';
import {Task} from '../../../../../data/tasks/task';
import {ProjectComment} from 'projects/app-misc/src/app/modules/project-misc/data/project/project-comment';
import {trackEntityById} from 'projects/core/src/public-api';
import {Subscription, timer} from 'rxjs';
import {Cabinet} from '../../../../../../../../../../app-misc/src/app/modules/cabinets/data/cabinet';
import {User} from 'projects/core/src/lib/login/data/user';

@Component({
  selector: 'app-task-comments',
  templateUrl: './task-comments.component.html',
  styleUrls: ['./task-comments.component.scss']
})
export class TaskCommentsComponent implements OnInit, OnDestroy {

  task: Task;
  users: User[]

  taskComments: ProjectComment[];

  loadingSpinner = false;

  itemDescription: string;

  trackEntityById = trackEntityById;

  commentsLoading = true;
  ctrlEventListener = null;

  constructor(
    protected tasksService: TasksService,
    protected el: ElementRef,
    protected dialogRef: MatDialogRef<TaskCommentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      task: Task,
      users: User[],
    }
  ) {
    this.task = this.data.task
    this.users = this.data.users
  }

  ngOnInit(): void {
    this.subToEnter();
    this.tasksService.getTaskComments(this.task.id).subscribe(comments => {
      this.taskComments = comments;

      this.commentsLoading = false;

      timer(10).subscribe(emit => {
        const element = document.getElementById('commentsList');
        element.scrollTop = element.scrollHeight;

        const textarr = this.el.nativeElement.getElementsByClassName('text-area-task-comment');
        (textarr[0] as HTMLElement).focus();
      })

    })

    this.markTask();
  }

  markTask() {
    this.tasksService.markTaskAsRead(this.task.id).subscribe(emit => {
      this.task.unreadComments = 0;
    })
  }

  subToEnter() {

    this.ctrlEventListener = (event: KeyboardEvent) => {
      this.enterSend(event)
    }

    document.addEventListener('keydown', this.ctrlEventListener);

  }

  enterSend(event) {
    const key = (event as KeyboardEvent).key;

    if (key === 'Enter') {
      if (this.itemDescription) {
        this.addComment();
      }
    }
  }

  addComment() {
    this.loadingSpinner = true;

    const commentData: ProjectComment = {
      id: null,
      text: this.itemDescription
    }

    this.tasksService.addTaskComment(this.task.id, commentData).subscribe(comment => {
      this.taskComments.push(comment)
      this.itemDescription = '';
      this.loadingSpinner = false;


      timer(10).subscribe(emit => {
        const element = document.getElementById('commentsList');
        element.scrollTop = element.scrollHeight;
      })

    }, error => {
      this.loadingSpinner = false;
    })
  }

  closeDialog() {
    this.dialogRef.close('close-button');
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.ctrlEventListener);
  }

  onMentionSelect(user: User) {
    return '@' + user.username + ' ';
  }
}
